export const entrypoint = "https://api.poissonsdedombes.fr";
export const baseUrl = "https://api.poissonsdedombes.fr";